// frontend/src/constants/messageFormats.js
export const ADMIN_MESSAGE_FORMATS = {
    ANNOUNCE_HOLD: 'announce_hold',
    ANNOUNCE_HOLD_CANCELLED: 'announce_hold_cancelled',
    ANNOUNCE_HOLD_DECLINE: 'announce_hold_decline',
    ANNOUNCE_CONTRACT: 'announce_contract',
    ANNOUNCE_CANCEL_COMP_DECIDED: 'announce_cancel_comp_decided',
    ANNOUNCE_INVOICE_RESUBMISSION_REQUESTED: 'announce_invoice_resubmission_requested',
    ANNOUNCE_PART_ASSIGNED: 'announce_part_assigned',
    ANNOUNCE_PART_CHANGED: 'announce_part_changed',
    ANNOUNCE_PART_UNASSIGNED: 'announce_part_unassigned',
    ANNOUNCE_STAGE_SEATING_SHARED: 'announce_stage_seating_shared',
    ANNOUNCE_CONTRACT_CANCELLED: 'announce_contract_cancelled',
    ANNOUNCE_CONTRACT_UPDATED:   'announce_contract_updated',
    ANNOUNCE_CONCIERGE_RESULT: 'announce_concierge_result',
    REMINDER_NOTICE: 'reminder_event',
    NOTE_CREATE: 'note_create',
    NOTE_UPDATE: 'note_update',
    NOTE_DELETE: 'note_delete',
    TIMETABLE_CREATED: 'timetable_created',
    TIMETABLE_UPDATED: 'timetable_updated',
    TIMETABLE_MEMO: 'timetable_memo',
    TIMETABLE_MEMO_ADMIN: 'timetable_memo_admin',
    TIMETABLE_ANNOUNCEMENT: 'timetable_announcement',
    TIMETABLE_ANNOUNCEMENT_ADMIN: 'timetable_announcement_admin',
    EVENT_MATERIAL_SHARED: 'event_material_shared',
    EVENT_IMAGES_ADDED: 'event_images_added',
    EVENT_INFO_UPDATED: 'event_info_updated',
    EVENT_INFO_PUBLISHED: 'event_info_published',
    EVENT_MEMBERS_PUBLISHED: 'event_members_published',
    STAGE_SEATING_SHARED: 'stage_seating_shared',
    EVENT_FINISHED: 'event_finished',
    TEXT: 'text',
    IMAGE: 'image',
    FILE: 'file',
    EVENT_CANCELLED: 'event_cancelled',
  };

export const LEGACY_ADMIN_MESSAGE_FORMATS = {
    INVOICE_RESUBMISSION_REQUESTED: 'invoice_resubmission_requested',
};

export const isHoldAnnouncementFormat = (format) => {
    const normalized = String(format || '').trim().toLowerCase();
    return (
      normalized === ADMIN_MESSAGE_FORMATS.ANNOUNCE_HOLD ||
      normalized === ADMIN_MESSAGE_FORMATS.ANNOUNCE_HOLD_CANCELLED
    );
};

export const isInvoiceResubmissionRequestedFormat = (format) => {
    const normalized = String(format || '').trim().toLowerCase();
    return (
      normalized === ADMIN_MESSAGE_FORMATS.ANNOUNCE_INVOICE_RESUBMISSION_REQUESTED ||
      normalized === LEGACY_ADMIN_MESSAGE_FORMATS.INVOICE_RESUBMISSION_REQUESTED
    );
};

export const isPartAnnouncementFormat = (format) => {
    const normalized = String(format || '').trim().toLowerCase();
    return (
      normalized === ADMIN_MESSAGE_FORMATS.ANNOUNCE_PART_ASSIGNED ||
      normalized === ADMIN_MESSAGE_FORMATS.ANNOUNCE_PART_CHANGED ||
      normalized === ADMIN_MESSAGE_FORMATS.ANNOUNCE_PART_UNASSIGNED
    );
};

export const isStageSeatingShareAnnouncementFormat = (format) => {
    const normalized = String(format || '').trim().toLowerCase();
    return (
      normalized === ADMIN_MESSAGE_FORMATS.ANNOUNCE_STAGE_SEATING_SHARED ||
      normalized === ADMIN_MESSAGE_FORMATS.STAGE_SEATING_SHARED ||
      normalized === 'announce_stage_seating_shared' ||
      normalized === 'stage_seating_shared'
    );
};
